import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom/es';
import Box from '../layout/Box';
import Icon from '../widgets/Icon';
import './styles.scss';

const TickerSeriesList = ({tickerSeries, onDelete, onClone}) => (
  <Box direction="column" className="ticker-series-list">
    {tickerSeries.map((item) => (
      <Box key={item.id} direction="row" alignItems="center" className="ticker-series">
        <Link className="tappable-link" to={`/tickers/${item.id}`}>{item.name}</Link>
        <div className="hide-for-small-only">
          {`${item.tickers.length} ticker${item.tickers.length !== 1 ? 's' : ''}`}
        </div>
        <Icon title="Create a copy"
              name="clone"
              size="1.5rem"
              onClick={() => onClone(item)}/>
        <Icon title="Delete"
              name="trash-o"
              size="1.5rem"
              onClick={() => onDelete(item)}/>
      </Box>
    ))}
  </Box>
);

TickerSeriesList.propTypes = {
  tickerSeries: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
};

export default TickerSeriesList;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TickerSeriesList/index.js